import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const Wrapper = styled.div`
    display: flex;
    width: 100%;
    margin-top: 30px;

    @media (max-width: 1023px) {
        flex-direction: column;
    }
`;

export const FiltersSearch = styled.div`
    width: 100%;
    min-height: 48px;
`;

export const ChannelsSelector = styled.div`
    flex-wrap: nowrap;
    width: 100%;
    gap: 12px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-wrap: wrap;

        button {
            width: 100%;
        }
    }
`;
